import { apiClient } from './apiClient';
import { LoginCredentials, RegisterData, AuthResponse, User, ApiResponse } from '../types';

class AuthService {
  async login(credentials: LoginCredentials): Promise<AuthResponse['data']> {
    const response = await apiClient.post<AuthResponse>('/auth?action=login', credentials);
    return response.data.data!;
  }

  async register(data: RegisterData): Promise<AuthResponse['data']> {
    const response = await apiClient.post<AuthResponse>('/auth?action=register', data);
    return response.data.data!;
  }

  async logout(): Promise<void> {
    try {
      await apiClient.post('/auth?action=logout');
    } catch (error) {
      // Ignore errors on logout, as token might already be invalid
    }
  }

  async refreshToken(refreshToken: string): Promise<{ accessToken: string; refreshToken: string }> {
    const response = await apiClient.post<ApiResponse<{ token: string; refreshToken: string }>>(
      '/auth?action=refresh',
      { refreshToken }
    );
    return { accessToken: response.data.data!.token, refreshToken: response.data.data!.refreshToken };
  }

  async getProfile(): Promise<User> {
    const response = await apiClient.get<ApiResponse<{ user: User }>>('/auth?action=profile');
    return response.data.data!.user;
  }

  async forgotPassword(email: string): Promise<string> {
    const response = await apiClient.post<ApiResponse<{ message: string }>>(
      '/auth/forgot-password',
      { email }
    );
    return response.data.message;
  }

  async resetPassword(token: string, newPassword: string): Promise<string> {
    const response = await apiClient.post<ApiResponse>(
      '/auth/reset-password',
      { token, newPassword }
    );
    return response.data.message;
  }
}

export const authService = new AuthService();